import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spinner } from '@/components/ui/Spinner';
import { useSchwabCallback } from '@/hooks/queries/useSchwab';

export function SchwabCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const callback = useSchwabCallback();
  const hasCalledRef = useRef(false);

  // Handle initial error from Schwab redirect
  useEffect(() => {
    const error = searchParams.get('error');
    if (error) {
      navigate('/settings/schwab?error=' + encodeURIComponent(error), { replace: true });
    }
  }, [searchParams, navigate]);

  // Trigger the callback mutation
  useEffect(() => {
    if (hasCalledRef.current) return;

    const code = searchParams.get('code');
    if (code && !callback.isPending && !callback.isSuccess && !callback.isError) {
      hasCalledRef.current = true;
      callback.mutate(code);
    }
  }, [searchParams, callback.isPending, callback.isSuccess, callback.isError, callback.mutate]);

  // Handle navigation based on mutation state
  useEffect(() => {
    if (callback.isSuccess) {
      navigate('/settings/schwab?connected=true', { replace: true });
    } else if (callback.isError) {
      const errorMessage = callback.error?.message || 'Failed to connect';
      navigate('/settings/schwab?error=' + encodeURIComponent(errorMessage), { replace: true });
    }
  }, [callback.isSuccess, callback.isError, callback.error, navigate]);

  return (
    <div className="min-h-[400px] flex flex-col items-center justify-center">
      <Spinner size="lg" />
      <p className="mt-4 text-gray-600">Connecting to Schwab...</p>
    </div>
  );
}
